import Vue from 'vue'
import axios from '@/util/axios'
import PortalVue from 'portal-vue'
import AsyncComputed from 'vue-async-computed'
import * as VueGoogleMaps from 'vue2-google-maps'
import VTooltip from 'v-tooltip'
import { VueMasonryPlugin } from 'vue-masonry'

Vue.use(PortalVue)
Vue.use(AsyncComputed)
Vue.use(VTooltip)
Vue.use(VueMasonryPlugin)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDs9eoLTLh2rMKYZPKq99FLFU8Ymqeauuc'
    }
});

export default class BananaMoon {
    constructor(config) {
        this.bus = new Vue()
        this.bootingCallbacks = []
        this.config = config
    }

    /**
     * Register a callback to be called before Bananamoon starts. This is used to bootstrap
     * addons, tools, custom fields, or anything else Bananamoon needs
     */
    booting(callback) {
        this.bootingCallbacks.push(callback)
    }

    /**
     * Execute all of the booting callbacks.
     */
    boot() {
        this.bootingCallbacks.forEach(callback => callback(Vue))

        this.bootingCallbacks = []
    }

    /**
     * Start the BananaMoon app by calling each of the tool's callbacks and then creating
     * the underlying Vue instance.
     */
    liftOff() {
        let _this = this

        this.boot()

        this.app = new Vue({
            el: '#bananamoon',
            data() {
                return {
                    contactModalOpen: false,
                    videoModalOpen: false,
                    adModalOpen: false,
                    menuOpen: false,
                    tourOpen: false,
                    videoUrl: '',
                    videoType: ''
                }
            }
        })
    }

    /**
     * Return an axios instance configured to make requests to Nova's API
     * and handle certain response codes.
     */
    request(options) {
        if (options !== undefined) {
            return axios(options)
        }

        return axios
    }

    /**
     * Register a listener on Nova's built-in event bus
     */
    $on(...args) {
        this.bus.$on(...args)
    }

    /**
     * Register a one-time listener on the event bus
     */
    $once(...args) {
        this.bus.$once(...args)
    }

    /**
     * Unregister an listener on the event bus
     */
    $off(...args) {
        this.bus.$off(...args)
    }

    /**
     * Emit an event on the event bus
     */
    $emit(...args) {
        this.bus.$emit(...args)
    }
}



// WEBPACK FOOTER //
// ./resources/js/BananaMoon.js